import { render } from "./App.vue?vue&type=template&id=bab6270a"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=bab6270a&lang=css"
script.render = render

export default script